import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Autocomplete,
	Button,
	Card,
	CardContent,
	Grid,
	Typography,
	Box,
	Stack
} from "@mui/material";
import TextField from "@mui/material/TextField";
import {IKalem, IKisi, IMesaiKayit} from "../../../constants/types/logbook";
import IconButton from "@mui/material/IconButton";
import {Delete, Undo, Engineering, AddCircleOutline, ExpandMore} from "@mui/icons-material";
import {TimePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";

const Mesailer = (
	{
		mesailer,
		setMesailer,
		calisanlar,
	}: {
		mesailer: IKalem<IMesaiKayit>,
		calisanlar: IKisi[]
		setMesailer: any,
	}) => {
	return (
		<Accordion
			elevation={0}
			sx={{
				backgroundColor: 'background.paper',
				borderRadius: '16px !important',
				border: '1px solid rgba(0,0,0,0.05)',
				mb: 1,
				overflow: 'hidden',
				'&:before': { display: 'none' }
			}}
		>
			<AccordionSummary expandIcon={<ExpandMore />}>
				<Stack direction="row" spacing={1.5} alignItems="center">
					<Engineering color="primary" />
					<Typography variant="h6" fontWeight={800} sx={{ textTransform: 'uppercase', letterSpacing: 1 }}>
						Mesailer
					</Typography>
					<Typography variant="caption" sx={{ bgcolor: 'primary.main', color: 'white', px: 1, py: 0.2, borderRadius: 1, fontWeight: 700 }}>
						{mesailer.data.length + mesailer.eklenenListe.length} Kayıt
					</Typography>
				</Stack>
			</AccordionSummary>
			<AccordionDetails sx={{ bgcolor: '#fcfcfc', p: { xs: 1, md: 1.5 } }}>
				<Grid container spacing={1}>
				{
					mesailer.data.map((mesai, mesaiIndex) => {
							const guncellenmis = mesailer.guncellenecekIdListe.includes(mesai.id ?? -1);
							const silinmis = mesailer.silinecekIdListe.includes(mesai.id ?? -1);
							if (guncellenmis) mesai = mesailer.guncellenecekListe[mesai.id ?? 0];
							const guncelle = (guncel: IMesaiKayit) => {
								setMesailer({
									...mesailer,
									guncellenecekIdListe: [...(guncellenmis ? mesailer.guncellenecekIdListe : [...mesailer.guncellenecekIdListe, mesai.id ?? 0])],
									guncellenecekListe: {...mesailer.guncellenecekListe, [mesai.id ?? 0]: guncel}
								})
							}
							return (
								<Grid item xs={12} key={"calisan-" + mesaiIndex}>
									<Card
										elevation={0}
										sx={{
											border: '1px solid',
											borderColor: guncellenmis ? 'info.light' : silinmis ? 'error.light' : 'rgba(0,0,0,0.08)',
											backgroundColor: guncellenmis ? 'info.light' : silinmis ? '#fff5f5' : '#fff',
											borderRadius: '12px',
											transition: 'all 0.2s'
										}}
									>
										<CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
											<Grid container spacing={1} alignItems="center">
												<Grid item xs={12} sm={3}>
													<Autocomplete
														size={"small"}
														disablePortal
														disabled={silinmis || (!!mesai.kisi && !calisanlar.find(q => q.id === mesai.kisi)?.aktif)}
														options={calisanlar.filter(q => q.aktif).map(q => q.id)}
														getOptionLabel={option => calisanlar.find(q => q.id === option)?.rumuz ?? ""}
														disableClearable
														renderInput={(params) => <TextField {...params} label="Çalışan"/>}
														value={mesai.kisi}
														onChange={(_, value) => {
															const guncel = {...mesai};
															guncel.kisi = value;
															guncelle(guncel);
														}}
													/>
												</Grid>
												<Grid item xs={12} sm={2.5}>
													<TimePicker
														disabled={silinmis || (!!mesai.kisi && !calisanlar.find(q => q.id === mesai.kisi)?.aktif)}
														label="Başlangıç"
														slotProps={{ textField: { size: 'small', fullWidth: true } }}
														value={dayjs(mesai.baslangic_saat, "HH:mm:ss")}
														onChange={(newValue) => {
															const guncel = {...mesai};
															guncel.baslangic_saat = newValue?.format("HH:mm:ss") ?? "00:00:00";
															guncelle(guncel);
														}}
													/>
												</Grid>
												<Grid item xs={6} sm={2}>
													<Autocomplete
														size={"small"}
														disablePortal
														disabled={silinmis || (!!mesai.kisi && !calisanlar.find(q => q.id === mesai.kisi)?.aktif)}
														options={[false, true]}
														getOptionLabel={(option: boolean) => option ? "Evet" : "Hayır"}
														disableClearable
														renderInput={(params) => <TextField {...params} label="Ekstra"/>}
														value={mesai.ekstra}
														onChange={(_, value) => {
															const guncel = {...mesai};
															guncel.ekstra = value;
															if (value) {
																guncel.tam_gun = false;
																guncel.saat = 0;
															} else {
																guncel.tam_gun = true;
																guncel.saat = 0;
															}
															guncelle(guncel);
														}}
													/>
												</Grid>
												<Grid item xs={6} sm={2}>
													<Autocomplete
														size={"small"}
														disablePortal
														options={[false, true]}
														disabled={silinmis || mesai?.ekstra || (!!mesai.kisi && !calisanlar.find(q => q.id === mesai.kisi)?.aktif)}
														getOptionLabel={(option: boolean) => option ? "Evet" : "Hayır"}
														disableClearable
														renderInput={(params) => <TextField {...params} label="Tam Gün"/>}
														value={mesai.tam_gun}
														onChange={(_, value) => {
															const guncel = {...mesai};
															guncel.tam_gun = value;
															if (value) {
																guncel.ekstra = false;
															}
															guncelle(guncel);
														}}
													/>
												</Grid>
												<Grid item xs={8} sm={1.5}>
													<TextField
														size={"small"}
														fullWidth
														disabled={silinmis || (!!mesai.kisi && !calisanlar.find(q => q.id === mesai.kisi)?.aktif)}
														type={"number"}
														label={"Saat"}
														value={"" + mesai.saat}
														onChange={(event) => {
															const guncel = {...mesai};
															const val = parseInt(event.target.value);
															guncel.saat = isNaN(val) ? 0 : val;
															guncelle(guncel);
														}}
													/>
												</Grid>
												<Grid item xs={4} sm={1}>
													<Stack direction="row" spacing={0.5} justifyContent="flex-end">
														<IconButton
															size="small"
															disabled={silinmis || (!!mesai.kisi && !calisanlar.find(q => q.id === mesai.kisi)?.aktif)}
															onClick={() => {
																setMesailer({
																	...mesailer,
																	silinecekIdListe: [...mesailer.silinecekIdListe, mesai.id ?? 0],
																})
															}}
															color={"error"}
															sx={{ bgcolor: 'error.light', '&:hover': { bgcolor: '#ffcdd2' } }}
														>
															<Delete fontSize="small" />
														</IconButton>
														<IconButton
															size="small"
															disabled={!guncellenmis && !silinmis}
															onClick={() => {
																if (guncellenmis) {
																	setMesailer({
																		...mesailer,
																		guncellenecekIdListe: mesailer.guncellenecekIdListe.filter(id => id !== mesai.id),
																	})
																} else {
																	setMesailer({
																		...mesailer,
																		silinecekIdListe: mesailer.silinecekIdListe.filter(id => id !== mesai.id),
																	})
																}
															}}
															color={"info"}
															sx={{ bgcolor: 'info.light', '&:hover': { bgcolor: '#b3e5fc' } }}
														>
															<Undo fontSize="small" />
														</IconButton>
													</Stack>
												</Grid>
											</Grid>
										</CardContent>
									</Card>
								</Grid>
							)
						}
					)
				}
				{
					mesailer.eklenenListe.map((mesai, mesaiIndex) => {
							const guncelle = (guncel: IMesaiKayit) => {
								setMesailer({
									...mesailer,
									eklenenListe: mesailer.eklenenListe.map((m, index) => {
										if (index === mesaiIndex) return guncel;
										return m;
									})
								})
							}
							return (
								<Grid item xs={12} key={"calisan_ekle-" + mesaiIndex}>
									<Card
										elevation={0}
										sx={{
											border: '2px dashed',
											borderColor: 'success.main',
											backgroundColor: '#f1fff1',
											borderRadius: '12px'
										}}
									>
										<CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
											<Grid container spacing={1} alignItems="center">
												<Grid item xs={12} sm={3}>
													<Autocomplete
														size={"small"}
														disablePortal
														options={calisanlar.filter(q => q.aktif).map(q => q.id)}
														getOptionLabel={option => calisanlar.find(q => q.id === option)?.rumuz ?? ""}
														disableClearable
														renderInput={(params) => <TextField {...params} label="Çalışan"/>}
														value={mesai.kisi}
														onChange={(_, value) => {
															const guncel = {...mesai};
															guncel.kisi = value;
															guncelle(guncel);
														}}
													/>
												</Grid>
												<Grid item xs={12} sm={2.5}>
													<TimePicker
														label="Başlangıç"
														slotProps={{ textField: { size: 'small', fullWidth: true } }}
														value={dayjs(mesai.baslangic_saat, "HH:mm:ss")}
														onChange={(newValue) => {
															const guncel = {...mesai};
															guncel.baslangic_saat = newValue?.format("HH:mm:ss") ?? "00:00:00";
															guncelle(guncel);
														}}
													/>
												</Grid>
												<Grid item xs={6} sm={2}>
													<Autocomplete
														size={"small"}
														disablePortal
														options={[false, true]}
														getOptionLabel={(option: boolean) => option ? "Evet" : "Hayır"}
														disableClearable
														renderInput={(params) => <TextField {...params} label="Ekstra"/>}
														value={mesai.ekstra}
														onChange={(_, value) => {
															const guncel = {...mesai};
															guncel.ekstra = value;
															if (value) {
																guncel.tam_gun = false;
																guncel.saat = 0;
															} else {
																guncel.tam_gun = true;
																guncel.saat = 0;
															}
															guncelle(guncel);
														}}
													/>
												</Grid>
												<Grid item xs={6} sm={2}>
													<Autocomplete
														size={"small"}
														disablePortal
														options={[false, true]}
														disabled={mesai?.ekstra}
														getOptionLabel={(option: boolean) => option ? "Evet" : "Hayır"}
														disableClearable
														renderInput={(params) => <TextField {...params} label="Tam Gün"/>}
														value={mesai.tam_gun}
														onChange={(_, value) => {
															const guncel = {...mesai};
															guncel.tam_gun = value;
															if (value) {
																guncel.ekstra = false;
															}
															guncelle(guncel);
														}}
													/>
												</Grid>
												<Grid item xs={10} sm={1.5}>
													<TextField
														size={"small"}
														fullWidth
														type={"number"}
														label={"Saat"}
														value={"" + mesai.saat}
														onChange={(event) => {
															const guncel = {...mesai};
															const val = parseInt(event.target.value);
															guncel.saat = isNaN(val) ? 0 : val;
															guncelle(guncel);
														}}
													/>
												</Grid>
												<Grid item xs={2} sm={1} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
													<IconButton
														size="small"
														onClick={() => {
															setMesailer({
																...mesailer,
																eklenenListe: mesailer.eklenenListe.filter((_, index) => index !== mesaiIndex)
															})
														}}
														color={"error"}
														sx={{ bgcolor: 'error.light', '&:hover': { bgcolor: '#ffcdd2' } }}
													>
														<Delete fontSize="small" />
													</IconButton>
												</Grid>
											</Grid>
										</CardContent>
									</Card>
								</Grid>
							)
						}
					)
				}
				<Grid item xs={12} sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
					<Button
						variant="outlined"
						startIcon={<AddCircleOutline />}
						onClick={() => {
							setMesailer({
								...mesailer,
								eklenenListe: [
									...mesailer.eklenenListe,
									{
										kisi: null as any,
										baslangic_saat: "00:00:00",
										tam_gun: true,
										saat: 0,
										ekstra: false
									}]
							})
						}}
						sx={{ 
							borderRadius: '10px', 
							textTransform: 'none', 
							fontWeight: 700,
							px: 4,
							borderWidth: '2px',
							'&:hover': { borderWidth: '2px' }
						}}
					>
						Yeni Mesai Ekle
					</Button>
				</Grid>
			</Grid>
		</AccordionDetails>
	</Accordion>
	);
}

export default Mesailer;